"use client";

import { Footer } from "@/components/footer";
import { Navbar } from "@/components/navbar";

export default function CookiePolicyPage() {
  return (
    <div className="marketing-surfaces min-h-screen bg-surface-base text-text-primary flex flex-col">
      <Navbar />

      <main className="flex-1 px-5 sm:px-8 py-12 max-w-3xl mx-auto w-full">
        <h1 className="text-3xl font-semibold tracking-tight mb-2">Cookie Policy</h1>
        <p className="text-base text-text-quaternary mb-8">Last updated: June 11, 2026</p>

        <div className="mb-10 rounded-2xl border border-brand/30 bg-brand/6 px-6 py-5">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand mb-2">
            In plain English
          </p>
          <p className="text-base text-text-secondary leading-relaxed">
            We use cookies and similar technologies to operate Encrata, keep it secure, remember
            your preferences, understand how our website is used, and improve our services.
            Necessary cookies help the site function and cannot be turned off. Optional cookies,
            such as analytics or preference cookies, are used only where permitted by law or with
            your consent. We do not use cookies to sell your personal data. You can change your
            choices at any time through our cookie settings or by contacting us.
          </p>
        </div>

        <div className="space-y-8 text-base text-text-secondary leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website. They
              help the site remember your preferences and keep you signed in. This policy explains
              which cookies Encrata uses and why.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">2. Cookies We Use</h2>
            <h3 className="font-medium text-text-primary mb-2">Strictly Necessary</h3>
            <p className="mb-3">
              Required for the Service to function - session authentication, CSRF protection, and
              load balancing. These cannot be disabled.
            </p>
            <h3 className="font-medium text-text-primary mb-2">Preferences</h3>
            <p className="mb-3">
              Remember your settings such as theme (dark/light) and language. Stored locally and
              never shared with third parties.
            </p>
            <h3 className="font-medium text-text-primary mb-2">Analytics</h3>
            <p>
              We use privacy-friendly, aggregated analytics to understand how the Service is used.
              We do not use cross-site tracking cookies or sell data to advertisers.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">3. Cookie Table</h2>
            <div className="overflow-x-auto rounded-(--radius-cards) border border-border-secondary">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-border-secondary bg-surface-raised text-left">
                    <th className="px-4 py-2.5 font-medium text-text-primary">Cookie</th>
                    <th className="px-4 py-2.5 font-medium text-text-primary">Purpose</th>
                    <th className="px-4 py-2.5 font-medium text-text-primary">Duration</th>
                  </tr>
                </thead>
                <tbody className="text-text-tertiary">
                  <tr className="border-b border-border-secondary">
                    <td className="px-4 py-2.5 font-mono text-xs">session</td>
                    <td className="px-4 py-2.5">Keeps you signed in to the dashboard</td>
                    <td className="px-4 py-2.5">30 days</td>
                  </tr>
                  <tr className="border-b border-border-secondary">
                    <td className="px-4 py-2.5 font-mono text-xs">locale</td>
                    <td className="px-4 py-2.5">Remembers your language preference</td>
                    <td className="px-4 py-2.5">1 year</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5 font-mono text-xs">theme</td>
                    <td className="px-4 py-2.5">Remembers dark/light mode</td>
                    <td className="px-4 py-2.5">1 year</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">4. Third-Party Cookies</h2>
            <p>
              Payment processing (Paddle) and support chat (Chatra) may set their own cookies
              when you interact with those features. Refer to their respective privacy policies
              for details.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">5. Managing Cookies</h2>
            <p>
              You can control or delete cookies through your browser settings. Blocking strictly
              necessary cookies may prevent you from signing in or using parts of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-text-primary mb-3">6. Contact</h2>
            <p>
              Questions about this policy? Email{" "}
              <a href="mailto:privacy@encrata.com" className="text-brand hover:underline">
                privacy@encrata.com
              </a>
              .
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
